<template>
    <div class="rounded-xl border border-gray-100 bg-gray-50">
        <button
            type="button"
            data-testid="accordion-toggle"
            :data-expanded="expanded"
            :data-complete="isComplete"
            class="flex w-full items-start justify-between gap-3 px-4 py-4 text-left md:px-6"
            @click="$emit('toggle')"
        >
            <div class="min-w-0">
                <div class="flex flex-wrap items-center gap-2">
                    <h4 class="text-sm font-semibold text-gray-900 md:text-base">
                        {{ title }}
                    </h4>
                    <span
                        class="rounded-full px-2 py-0.5 text-[11px] font-semibold"
                        :class="isComplete ? 'bg-green-100 text-green-700' : 'bg-gray-200 text-gray-600'"
                    >
                        {{ isComplete ? 'Lengkap' : 'Belum diisi' }}
                    </span>
                </div>
                <p class="mt-1 truncate text-xs text-gray-600 md:text-sm">
                    {{ summary || "Belum diisi" }}
                </p>
            </div>

            <AppIcon
                :icon="expanded ? 'mdi:chevron-up' : 'mdi:chevron-down'"
                class="mt-0.5 h-5 w-5 shrink-0 text-gray-500"
            />
        </button>

        <transition name="accordion-fade">
            <div v-show="expanded" class="border-t border-gray-100 px-4 py-4 md:px-6 md:py-5">
                <p v-if="helperText" class="mb-4 text-xs text-gray-500 md:text-sm">
                    {{ helperText }}
                </p>
                <slot />
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "AccordionSection",
    props: {
        title: {
            type: String,
            required: true,
        },
        summary: {
            type: String,
            default: "",
        },
        helperText: {
            type: String,
            default: "",
        },
        expanded: {
            type: Boolean,
            default: false,
        },
        isComplete: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
.accordion-fade-enter-active,
.accordion-fade-leave-active {
    transition: all 0.2s ease;
}

.accordion-fade-enter-from,
.accordion-fade-leave-to {
    opacity: 0;
    transform: translateY(-4px);
}
</style>
